export default {
  free_menu_items: 'Sbloccati gratis',
  discount_badge: '{{value}} di sconto',
  available_at_badge: 'Disponibile {{schedule}}',
  restricted_tooltip: "Disponibile {{schedule}} — modifica l'orario di ritiro sopra per ordinare.",
};
